export default class ArrayHelper {
    static removeWhere(arr, compareFunc) {
        if (!arr) {
            return [];
        }

        const removedItems = [];
        let i = 0;

        while (i < arr.length) {
            if (compareFunc(arr[i])) {
                removedItems.push(arr[i]);
                arr.splice(i, 1);
            } else {
                i++;
            }
        }

        return removedItems;
    }
}